import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface CreatorBasicInfoProps {
  formData: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function CreatorBasicInfo({ formData, handleInputChange }: CreatorBasicInfoProps) {
  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="name">Name</Label>
          <Input
            id="name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="surname">Surname</Label>
          <Input
            id="surname"
            name="surname"
            value={formData.surname}
            onChange={handleInputChange}
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="nick_name">Nickname (Optional)</Label>
        <Input
          id="nick_name"
          name="nick_name"
          value={formData.nick_name || ""}
          onChange={handleInputChange}
        />
      </div>
    </>
  );
}